import { WorkPackageCollectionHalSource, WorkPackageCollectionHalSourceProps } from "@/halSources";
import request from "../request";

export const getWorkPackages = async (params?: any) => {
  const result = await request.get<any, WorkPackageCollectionHalSourceProps>(`/workbenchApi/api/v3/work_packages`, {
    params,
  });
  return new WorkPackageCollectionHalSource(result);
};
export const getAllProjectWorkPackages = async (id: number | string, reqParams?: any) => {
  const params = {
    pageSize: 50,
    showHierarchies: false,
    filters: JSON.stringify([{ "status": { "operator": "*", "values": [] } }]),
    sortBy: JSON.stringify([["updatedAt", "desc"]]),
    ...reqParams
  };
  const result = await request.get<any, WorkPackageCollectionHalSourceProps>(`/workbenchApi/api/v3/projects/${id}/work_packages`, {
    params,
  });
  return new WorkPackageCollectionHalSource(result);
};